<template>
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div
        class="group my-4 w-full rounded-lg border border-iron-200 bg-white px-4 py-5 shadow-sm transition-all duration-200 hover:shadow-md"
    >
        <div class="items-center justify-between space-x-3 sm:flex">
            <div class="flex items-center gap-2">
                <div class="flex-shrink-0"></div>
                <div class="min-w-0 flex-1">
                    <p class="font-medium text-iron-900">
                        {{ availability.name }}
                    </p>
                    <p
                        v-for="(readableAvailabilityDate, key) in days"
                        :key="key"
                        class="text-sm text-iron-700"
                    >
                        {{ readableAvailabilityDate }}
                    </p>
                </div>
            </div>

            <div
                class="mt-3 flex flex-shrink-0 justify-start self-center sm:mt-0"
            >
                <div class="inline-flex rounded-md shadow-sm">
                    <ManageAvailabilityModal
                        :availability-id="availability.id"
                        :availability-name="availability.name"
                        :days="editableDays"
                    >
                        <button
                            class="relative -ml-px inline-flex items-center gap-2 rounded-l-md rounded-r-md bg-white px-3 py-2 text-sm font-medium text-iron-900 ring-1 ring-inset ring-iron-300 hover:bg-iron-50 focus:z-10"
                        >
                            <Pencil :size="20" :stroke-width="1.5" />
                            <span class="hidden sm:inline-block">{{
                                $t("edit")
                            }}</span>
                        </button>
                    </ManageAvailabilityModal>

                    <button
                        class="relative ml-2 inline-flex items-center gap-2 rounded-l-md rounded-r-md bg-white px-3 py-2 text-sm font-medium text-iron-900 ring-1 ring-inset ring-iron-300 hover:bg-iron-50 focus:z-10"
                        @click="removeAvailability"
                    >
                        <Trash2 :size="20" :stroke-width="1.5" />
                        <span class="hidden sm:inline-block">{{
                            $t("remove")
                        }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import useConfirm from "../../ConfirmDialog/composables/useConfirm";
import { useI18n } from "vue-i18n";
import ManageAvailabilityModal from "./ManageAvailabilityModal.vue";
import { Pencil, Trash2 } from "lucide-vue-next";
import { useEditableDays } from "../composables/useEditableDays";

const props = defineProps<{
    availability: {
        id: number;
        name: string;
        readableAvailabilityDates: Array<string>;
        availability_dates: Array<any>;
    };
    days: {
        required: true;
    };
}>();

const { days: editableDays } = useEditableDays(props.availability);
const { show } = useConfirm();
const { t } = useI18n();

const removeAvailability = async () => {
    const result = await show({
        header: t("availability.availability_preview.are_you_sure"),
        message: t("availability.availability_preview.delete"),
        confirm: t("availability.availability_preview.remove"),
        cancel: t("cancel"),
    });

    if (result) {
        await router.delete(`availabilities/${props.availability.id}`);
    }
};
</script>

<style>
@import url("/node_modules/@zaptime/vue3/dist/style.css");
</style>
